import { Flex } from 'foundations-components/components/Flex';
import { ArtificialIntelligenceEnhancedIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceEnhancedIcon';
import { Button } from 'foundations-components/transitional/components/Button';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { keyframes } from 'styled-components';
import { useCallback, useEffect, useRef } from 'react';
import { usePlanQuizTracking } from './planQuizTracking';
import { usePlanQuizState } from './PlanQuizContext';
import { useHelpMeChooseAffordance } from './useHelpMeChooseAffordance';
import GradientTraceBorder from './GradientTraceBorder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const sparkleRotate = keyframes(["0%{transform:rotate(0deg) scale(1);}25%{transform:rotate(-8deg) scale(1.15);}50%{transform:rotate(8deg) scale(1.1);}75%{transform:rotate(-4deg) scale(1.05);}100%{transform:rotate(0deg) scale(1);}"]);
const SparkleIcon = styled.span.withConfig({
  displayName: "HelpMeChooseInline__SparkleIcon"
})(["display:flex;align-items:center;transition:filter 0.2s;button:hover &{animation:", " 0.6s ease-in-out;filter:drop-shadow(0 0 3px rgba(255,72,0,0.4));}"], sparkleRotate);
const HelpMeChooseInline = ({
  onOpenPlanQuiz,
  impressionGuardRef
}) => {
  const {
    recommendation,
    step,
    flow,
    emailOrLink,
    selectedUseCases,
    teamSize
  } = usePlanQuizState();
  const hasRecommendation = recommendation !== null;
  const localImpressionGuard = useRef(false);
  const hasTrackedImpression = impressionGuardRef !== null && impressionGuardRef !== void 0 ? impressionGuardRef : localImpressionGuard;
  const {
    phase,
    notifyVisible,
    notifyOpened
  } = useHelpMeChooseAffordance();
  const {
    trackHelpMeChooseImpression,
    trackQuizModalOpen
  } = usePlanQuizTracking();
  const handleClick = useCallback(() => {
    notifyOpened();
    trackQuizModalOpen({
      step,
      flow,
      emailOrLink,
      selectedUseCases,
      teamSize
    });
    onOpenPlanQuiz === null || onOpenPlanQuiz === void 0 || onOpenPlanQuiz();
  }, [notifyOpened, trackQuizModalOpen, step, flow, emailOrLink, selectedUseCases, teamSize, onOpenPlanQuiz]);
  useEffect(() => {
    if (!hasTrackedImpression.current) {
      hasTrackedImpression.current = true;
      trackHelpMeChooseImpression();
    }
  }, [trackHelpMeChooseImpression, hasTrackedImpression]);
  const handleIntersectionChange = useCallback(({
    entries
  }) => {
    if (entries[0].isIntersecting) {
      notifyVisible();
    }
  }, [notifyVisible]);
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    onIntersectionChange: handleIntersectionChange,
    renderContent: () => /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      children: /*#__PURE__*/_jsx(GradientTraceBorder, {
        phase: phase,
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: handleClick,
          "data-selenium-id": "fsc-help-me-choose-button",
          "data-style": hasRecommendation ? 'text-orange-08' : 'text-neutral-13',
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "200",
            "data-style": "font-weight-500",
            children: [/*#__PURE__*/_jsx(SparkleIcon, {
              children: /*#__PURE__*/_jsx(ArtificialIntelligenceEnhancedIcon, {
                size: "300",
                color: "inherit"
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: hasRecommendation ? 'planQuiz.seeYourRecommendation' : 'planQuiz.helpMeChoose'
            })]
          })
        })
      })
    })
  });
};
export default HelpMeChooseInline;